let routelink = ["ViewAttachment","Meeting","AddMeeting","webview","sourcequery","Refer","urlqueryexec","KPIPendencyList","KPIPendency","KPI","SaveData","ManagerQRScan","DynamicReport","UserProfile", "Ticket","LeaderboardReport","Home","EmpTimeline","TicketList","EmpApprovals","EmpLeaves","WorkHistory","Activity","RedFlag","Meeting",];
export const modifiedSummary = (html) => {
  if (!html) return html;

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  doc.querySelectorAll("a").forEach((a) => {
    const href = a.getAttribute("href");
    if (!href) return;
      if (routelink.some(key => href.includes(key))) {
  a.setAttribute("data-href", href);
  a.removeAttribute("href");
}
    
  });

  return doc.body.innerHTML;
};